import * as React from 'react'
import { connect } from 'react-redux'
import type { ImageProps } from 'types/content-editor'
import type { State } from 'types/redux'
import api from '@disco/api/server'
import FileSelector from 'components/ui/file-selector'
import Input from 'components/ui/input'
import Label from 'components/ui/label'
type Props = {
  csrfToken: string
  value: ImageProps
  className?: string
  onChange: (e: React.SyntheticEvent<any>) => any
  onImageSet: (arg0: ImageProps) => any
  onImageUpload: () => any
  maxImageWidth?: number
  validationErrors:
    | {
        src?: string
        link?: string
      }
    | null
    | undefined
}

const mapStateToProps = (state: State) => {
  return {
    csrfToken: state.user.csrfToken,
  }
}

class ImagePropsView extends React.Component<
  Props,
  {
    uploading: boolean
  }
> {
  state = {
    uploading: false,
  }
  _abortController: AbortController | null | undefined

  componentWillUnmount() {
    if (this._abortController) this._abortController.abort()
  }

  _processImageFiles = async (files: Array<File>) => {
    const file = files[0]
    if (!file) return
    this.setState({
      uploading: true,
    })
    this.props.onImageUpload()
    this._abortController = new AbortController()
    const upload = await api.uploadEmailImage(
      file,
      this._abortController.signal,
    )
    this.setState({
      uploading: false,
    })
    this.props.onImageSet({
      src: upload.public_url,
    })
  }
  _handleFile = (files: Array<File> | null | undefined) => {
    // handle images only
    if (!files)
      return this.props.onImageSet({
        src: '',
      })
    const imageFiles = files.filter(f => f.type.startsWith('image/'))
    if (imageFiles.length === 0) return

    this._processImageFiles(imageFiles)
  }

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    if (
      nextProps.value !== this.props.value &&
      nextProps.value.src !== this.props.value.src &&
      nextProps.value.src
    ) {
      const image = new Image()
      image.src = nextProps.value.src

      image.onload = () => {
        const aspectRatio = image.width / image.height
        const adjustedWidth =
          !nextProps.maxImageWidth || image.width <= nextProps.maxImageWidth
            ? image.width
            : nextProps.maxImageWidth
        const adjustedHeight = Math.floor(adjustedWidth / aspectRatio)
        this.props.onImageSet({
          src: nextProps.value.src,
          width: adjustedWidth.toString(),
          height: adjustedHeight.toString(),
          aspectRatio,
        })
      }
    }
  }

  render() {
    const { src, link, width, height, alt } = this.props.value
    return (
      <div className={this.props.className}>
        <div className="rich-text-toolbar__settings__list__row">
          <Label
            validationError={
              this.props.validationErrors && this.props.validationErrors.src
            }
            caption="Location"
          />
          <Input
            value={src || ''}
            name="src"
            onChange={this.props.onChange}
            className="Campaigns_LargeInput"
          />
        </div>
        <div className="rich-text-toolbar__settings__list__row">
          <Label caption={this.state.uploading ? 'Uploading...' : 'Upload'} />
          <FileSelector
            dnd
            image={src}
            showPreview
            type="image"
            onDrop={this._handleFile}
          />
        </div>
        <div className="rich-text-toolbar__settings__list__row">
          <Label caption="Alt Text" />
          <Input
            value={alt || ''}
            name="alt"
            onChange={this.props.onChange}
            className="Campaigns_LargeInput"
          />
        </div>
        <div className="rich-text-toolbar__settings__list__row">
          <Label
            caption="Link"
            validationError={
              this.props.validationErrors && this.props.validationErrors.link
            }
          />
          <Input
            value={link || ''}
            name="link"
            onChange={this.props.onChange}
            className="Campaigns_LargeInput"
          />
        </div>
        <div className="rich-text-toolbar__settings__list__row">
          <Label caption="Width" />
          <Input
            value={width || ''}
            name="width"
            onChange={this.props.onChange}
            className="Campaigns_LargeInput"
          />
        </div>
        <div className="rich-text-toolbar__settings__list__row">
          <Label caption="Height" />
          <Input
            value={height || ''}
            name="height"
            onChange={this.props.onChange}
            className="Campaigns_LargeInput"
          />
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, {})(ImagePropsView) as any
